// src/pages/ConsultsPage.js (VERSIÓN FINAL Y CORREGIDA)

import React from 'react';
import { useNavigate } from 'react-router-dom';
// ✅ CORREGIR LA CAPITALIZACIÓN DEL CSS: Asegúrate que el nombre del archivo CSS es perfecto.
import './ConsultsPage.css'; 
// Importamos todos los íconos necesarios
import { 
    FiClock, 
    FiCalendar, 
    FiStar, 
    FiArrowLeft, 
    FiCreditCard, 
    FiSmartphone, 
    FiSend 
} from 'react-icons/fi';

const consultOptions = [
    {
        time: "30 Minutos",
        description: "Perfecta para preguntas rápidas o aclarar dudas específicas. Recibe orientación concisa y efectiva.",
        price: "$100.00 USD", 
        type: "Consulta de 30 Minutos",
        icon: <FiClock size={30} />,
        path: '/consultas/30-minutos' 
    },
    {
        time: "1 Hora",
        description: "Ideal para un análisis más profundo. Discute tus inquietudes en detalle y recibe asesoría personalizada.",
        price: "$190.00 USD",
        type: "Consulta de 1 Hora",
        icon: <FiCalendar size={30} />,
        path: '/consultas/1-hora' 
    },
    {
        time: "Consulta Especial",
        description: "Diseñada para casos exhaustivos y complejos. Desarrolla un plan adaptado a tus necesidades específicas.",
        price: "Precio A Convenir",
        type: "Consulta Especial",
        icon: <FiStar size={30} />,
        path: '/consultas/especial' 
    },
];

const paymentMethods = [
    { name: "Zelle", icon: <FiCreditCard size={20} /> },
    { name: "Pago Móvil", icon: <FiSmartphone size={20} /> },
    { name: "Transferencias Bancarias", icon: <FiSend size={20} /> }, 
];

const ConsultsPage = () => { 
    const navigate = useNavigate(); 
    
    const handleAgendaClick = (path) => {
        navigate(path);
    };

    return (
        <div className="page-container consults-page">
            {/* ✅ CORRECCIÓN DE BOTÓN: Apuntando a /servicios o /inicio según necesites */}
            {/* Si quieres que el botón "Volver" te lleve a la lista de servicios legales, usa '/servicios' */}
            <button className="back-button" onClick={() => navigate('/servicios')}> 
                <FiArrowLeft /> Volver a Servicios
            </button>
            
            <header className="consulting-hero">
                <h1>Elige Tu Asesoría Especializada</h1>
                <p>Contrata una consulta directa con nuestros expertos para un análisis profundo de tu caso.</p>
            </header>
            
            {/* SECCIÓN DE CONSULTAS (GRID) */}
            <section id="contacto" className="section consults-container">
                <h2>¡Consulta Online con Nuestros Expertos!</h2>
                <p className="consults-intro">Ofrecemos diferentes tipos de consultas para adaptarnos a tus necesidades:</p>
                
                <div className="consults-grid">
                    {consultOptions.map((option, index) => (
                        <div key={index} className="consult-option">
                            <div className="consult-icon">{option.icon}</div>
                            <h3>{option.time}</h3>
                            <p>{option.description}</p>
                            <p className="price">Precio Habitual: <strong>{option.price}</strong></p> 
                            
                            <button 
                                className="cta-button primary"
                                onClick={() => handleAgendaClick(option.path)}
                            >
                                Agendar {option.type}
                            </button>
                        </div>
                    ))}
                </div>

                <div className="payment-methods-box">
                    <h4>Formas de Pago Disponibles</h4>
                    <div className="payment-list-grid">
                        {paymentMethods.map((method, index) => (
                            <div key={index} className="payment-method-item">
                                {method.icon}
                                <span>{method.name}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <h3 style={{ marginTop: '30px', color: '#000033' }}>¡Contáctanos y Agenda tu Consulta hoy mismo!</h3>
                
                {/* FORMULARIO DE CONTACTO */}
                <form className="contact-form-grid">
                    <input type="text" placeholder="Nombre" required />
                    <input type="email" placeholder="Correo electrónico *" required />
                    <input type="tel" placeholder="Número de teléfono" />
                    <textarea placeholder="Comentario" className="full-width-input"></textarea>
                    <button type="submit" className="cta-button primary send-button">Enviar</button>
                </form>
                
                <p className="privacy-note">Valoramos tu privacidad... Toda la información que nos proporciones estará encriptada y protegida, garantizando que tus consultas y respuestas sean completamente confidenciales.</p>
            </section>
        </div>
    );
};

export default ConsultsPage;